__turbopack_context__.v({
  "customTimeWrapper": "timePicker-module-scss-module__WRyDrq__customTimeWrapper",
  "dayPeriods": "timePicker-module-scss-module__WRyDrq__dayPeriods",
  "icon": "timePicker-module-scss-module__WRyDrq__icon",
  "iconBottom": "timePicker-module-scss-module__WRyDrq__iconBottom",
  "iconTop": "timePicker-module-scss-module__WRyDrq__iconTop",
  "pickerPopper": "timePicker-module-scss-module__WRyDrq__pickerPopper",
  "sectorButton": "timePicker-module-scss-module__WRyDrq__sectorButton",
  "sectorInput": "timePicker-module-scss-module__WRyDrq__sectorInput",
  "timePicker": "timePicker-module-scss-module__WRyDrq__timePicker",
  "timeSector": "timePicker-module-scss-module__WRyDrq__timeSector",
});
